import React from 'react';

import ResourceForm, {
  FormFieldDefinition,
  FormFieldOption,
  ResourceFormProps,
} from '../components/./Form/ResourceForm';
import { InputType } from '../components/./Form/types';
import { appName } from '../lib/config';

const formFields: FormFieldDefinition<'events'>[] = [
  {
    attribute: 'departmentId',
    label: 'Gebied',
    required: true,
    type: InputType.Search,
    resourceType: 'departments',
    if: ({ resource, session }) => !resource && session.attributes.multipleManagedDepartments,
  },
  {
    attribute: 'name',
    label: 'Titel',
    required: true,
    type: InputType.Text,
  },
  { attribute: 'happensAt', type: InputType.DateTime, label: 'Datum & tijd', required: true },
  {
    attribute: 'endsAt',
    type: InputType.DateTime,
    label: 'Einddatum & -tijd',
    helper: 'Je kan dit veld ook leeglaten.',
  },
  {
    attribute: 'eventType',
    required: true,
    label: 'Type actie',
    type: InputType.Select,
    options: [
      (appName === 'glapp' && { key: 'slot_event', label: 'Eindsprint' }) as FormFieldOption,
      { key: 'canvas_event', label: 'Huis-aan-huizen' },
      { key: 'meeting_event', label: 'Bijeenkomst' },
    ].filter(Boolean),
  },
  { attribute: 'location', required: true, type: InputType.Text, label: 'Locatie' },
  { attribute: 'lat', type: InputType.Hidden },
  { attribute: 'lon', type: InputType.Hidden },
  { attribute: 'coordinates', type: InputType.Location, label: 'Toon op kaart' },
  {
    attribute: 'desiredCount',
    required: true,
    type: InputType.Number,
    label: 'Vrijwilligers nodig',
    helper: 'Zet op 0 als er geen limiet is.',
  },
  {
    attribute: 'description',
    label: 'Beschrijving',
    type: InputType.TextArea,
  },
];

const EventForm = (props: Partial<ResourceFormProps<'events'>>) => (
  <ResourceForm
    fields={formFields}
    type="events"
    {...props}
    defaultValues={{ eventType: 'canvas_event', desiredCount: 0, ...props.defaultValues }}
  />
);

export default EventForm;
